// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_RunStatusResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /migration/franquias/run/{id}?depois_de={ultimo_log_id}
 * (controllers/migration/franquias.php::run).
 *
 * O estado de UMA execucao mais o DELTA da linha do tempo — e o que faz a tela
 * de migracao contar o que esta acontecendo enquanto acontece.
 *
 * ---------------------------------------------------------------------------
 * POR QUE ISTO FUNCIONA SEM FILA, SEM WORKER E SEM SSE
 * ---------------------------------------------------------------------------
 * A requisicao que MIGRA escreve `migration_log` fase a fase e vai atualizando
 * as contagens do run enquanto trabalha. Esta requisicao, que e OUTRA e roda em
 * outro processo PHP-FPM, so le o que ja foi commitado. Nao ha estado
 * compartilhado em memoria, nao ha canal aberto: o banco e o canal.
 *
 * ---------------------------------------------------------------------------
 * DELTA, NUNCA A LINHA DO TEMPO INTEIRA
 * ---------------------------------------------------------------------------
 * A tela guarda o `ultimo_log_id` que recebeu e o manda de volta em
 * `depois_de` na consulta seguinte, a cada ~2s. Sem isso, uma execucao de 35
 * franquias (~200 linhas) rebaixaria a timeline inteira a cada ciclo, e o custo
 * cresceria com o QUADRADO da duracao da carga.
 *
 * `ultimo_log_id` vem do servidor de proposito: se a tela o calculasse do lado
 * dela, uma resposta vazia a faria repetir o ultimo `depois_de` — o que esta
 * certo — mas qualquer divergencia de tipo (o id e int, nao string) viraria um
 * loop pedindo sempre o mesmo trecho. Devolver o cursor junto com o dado tira
 * essa decisao do cliente.
 *
 * A barra de progresso sai de `run`: `n_created + n_skipped + n_failed` de
 * `n_source`. O fim vem de `run.status` deixar de ser 'running'.
 *
 * ---------------------------------------------------------------------------
 * A PAGINACAO MORA AQUI, NAO NO CONTROLLER
 * ---------------------------------------------------------------------------
 * `montar()` e `doDiario()` sao a UNICA implementacao da regra do delta: o
 * `limite + 1` que descobre `ha_mais` sem um COUNT separado, o corte da linha
 * extra, e o cursor que NAO volta a zero quando nao houve linha nova.
 *
 * Elas nasceram aqui porque enquanto viviam soltas dentro de `Franquias::run()`
 * nenhum teste conseguia alcanca-las: a tier contract nao chega a resposta de
 * sucesso destes endpoints (o gate de ambiente esta ausente do FPM de teste, de
 * proposito) e o teste de component precisava REIMPLEMENTAR o controller para
 * exercitar o resto. Reimplementacao vira dublê mais permissivo que o real — o
 * de la fixava `ha_mais = false`, entao a regra nunca podia reprovar. Com a
 * logica chamavel, producao e teste chamam A MESMA funcao e nao tem como
 * divergir.
 */
import type { Migration_LogLinhaRow } from './Migration_LogLinhaRow'
import type { Migration_RunRow } from './Migration_RunRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_RunStatusResponseDados {
linhas: Migration_LogLinhaRow[]
ultimo_log_id: number
ha_mais: boolean
run?: Migration_RunRow
}

export type Migration_RunStatusResponse = ApiResponse<Migration_RunStatusResponseDados>;

registerResponseContract('Migration_RunStatusResponse', {
  linhas: {
    type: 'array',
    required: true,
    items: {
      id:          { type: 'number',  required: false },
      nivel:       { type: 'string',  required: false },
      etapa:       { type: 'string',  required: false },
      entity_type: { type: 'string',  required: false },
      zoho_id:     { type: 'string',  required: false },
      mensagem:    { type: 'string',  required: false },
      contexto:    { type: 'string',  required: false },
      created_at:  { type: 'string',  required: false },
    },
  },
  ultimo_log_id: { type: 'number',  required: true },
  ha_mais:       { type: 'boolean', required: true },
  run: {
    type: 'object',
    required: false,
    fields: {
      id:          { type: 'number',  required: false },
      etapa:       { type: 'string',  required: false },
      zoho_id:     { type: 'string',  required: false },
      franquia_id: { type: 'number',  required: false },
      status:      { type: 'string',  required: false },
      n_source:    { type: 'number',  required: false },
      n_created:   { type: 'number',  required: false },
      n_skipped:   { type: 'number',  required: false },
      n_failed:    { type: 'number',  required: false },
      n_blocked:   { type: 'number',  required: false },
      started_by:  { type: 'string',  required: false },
      started_at:  { type: 'string',  required: false },
      finished_at: { type: 'string',  required: false },
    },
  },
})
